/* eslint-disable no-console */
import {
  ButtonCancel,
  ButtonSave,
  WrapPopover
} from './styles';

/* 
  *Importa o componente e o hook personalizado da biblioteca react-color-pallete
*/
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";

/**
 * PaletteColor
 * 
 * @param {string} paramColor Traz a cor individual de cada feição
 * @param {state} anchorElColor State responsavel por abertura do popup
 * @param {function} handleConfirmColor Set a cor do componente na feição individual
 * @param {function} handleCloseColor State responsavel por fechar o popup do colorpicker
 * 
 * @returns 
 */
const PaletteColor = ({ paramColor, anchorElColor, handleConfirmColor, handleCloseColor }) => {
  
  const [color, setColor] = useColor("hex", paramColor);  

  return (
    <WrapPopover
        anchorEl={anchorElColor}
        open={Boolean(anchorElColor)}
        onClose={handleCloseColor}
        anchorOrigin={{
        vertical: -205,
        horizontal: 25,
        }}
    >   
        <ColorPicker 
        width={230} 
        height={180} 
        color={color} 
        onChange={setColor} 
        hideHSV 
        light 
        />
            <div className='divButtons'>
              <ButtonCancel                              
                className='buttonsColorPicker'
                onClick={handleCloseColor}
              >
                Cancelar
              </ButtonCancel>
              <ButtonSave 
                className='buttonsColorPicker'             
                onClick={() => {
                  handleConfirmColor(color.hex);
                }}
              >
                Salvar
              </ButtonSave>
            </div>         
    </WrapPopover>
  );
};

export default PaletteColor;